import React from 'react'
import styled from 'styled-components'
import { Modal, ModalContainer } from '../../styled/modals'
import { Card, CardBody } from '../../styled/cards'
import { useTypedSelector, useTranslation } from '../../../hooks'
import ButtonSpinnerWhite from '../../layout/spinner/ButtonSpinnerWhite'

const CardHeader = styled.div`
    height: 5rem;
    padding: 0 1.4rem;
    font-size: 1.4rem;
    font-weight: 600;
    color: ${({ theme }) => theme.primary};

    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }) => theme.grey};
`

const CloseButton = styled.p`
    font-size: 1.4rem;
    color: ${({ theme }) => `${theme.primary}90`};
    padding: 1rem;
    cursor: pointer;
`

const ModalHeading = styled.h2`
    font-size: 1.8rem;
    text-align: center;
    margin-top: 2.3rem;
`

const CaseworkerName = styled.h2`
    font-weight: 700;
    text-align: center;
    font-size: 2rem;
    margin: 2.3rem 0;
`

const ButtonContainer = styled.div`
    display: flex;
    gap: 2.6rem;
    justify-content: center;
    margin-top: 2rem;
`

const UnassignButton = styled.div`
    height: 4.5rem;
    width: 24.3rem;
    background: ${({ theme }) => theme.red};
    color: ${({ theme }) => theme.white};
    font-size: 1.6rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    border-radius: 10rem;

    &:hover {
        opacity: 0.8;
    }
`

const CancelButton = styled.div`
    height: 4.5rem;
    width: 24.3rem;
    background: transparent;
    color: ${({ theme }) => theme.primary}60;
    font-size: 1.6rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    border-radius: 5rem;
    border: solid 0.1rem ${({ theme }) => theme.primary}60;

    &:hover {
        opacity: 0.8;
    }
`

interface UnassignCaseworkerModalProps {
    contact: any
    closeModal: () => void
    handleUnassign: () => void
}

const UnassignCaseworkerModal: React.FC<UnassignCaseworkerModalProps> = ({
    contact,
    closeModal,
    handleUnassign,
}) => {
    const translation = useTranslation()

    const { first_name, last_name } = contact

    const { lineOfContactDeleteLoading } = useTypedSelector(
        (state) => state.lineOfContact
    )

    const handleUnassignContact = async () => {
        await handleUnassign()

        closeModal()
    }

    return (
        <ModalContainer>
            <Modal height="25rem" width="50rem">
                <Card>
                    <CardHeader>
                        {translation.singleClientViewPartner
                            .unassignCaseworker || 'Unassign'}
                        <CloseButton onClick={closeModal}>
                            {translation.closeButton.close}
                        </CloseButton>
                    </CardHeader>
                    <CardBody
                        style={{
                            padding: '1.4rem',
                        }}
                    >
                        <ModalHeading>
                            {translation.singleClientViewPartner
                                .youAreAboutToUnassign ||
                                'Are you sure you want to unassign'}
                            <CaseworkerName>{`${first_name} ${last_name}`}</CaseworkerName>
                        </ModalHeading>

                        <ButtonContainer>
                            <CancelButton onClick={closeModal}>
                                {translation.reusable.cancel}
                            </CancelButton>
                            <UnassignButton onClick={handleUnassignContact}>
                                {lineOfContactDeleteLoading ? (
                                    <ButtonSpinnerWhite />
                                ) : (
                                    translation.singleClientViewPartner
                                        .confirmUnassign || 'Unassign'
                                )}
                            </UnassignButton>
                        </ButtonContainer>
                    </CardBody>
                </Card>
            </Modal>
        </ModalContainer>
    )
}

export default UnassignCaseworkerModal
